import ReactDom from 'react-dom'
import React from 'react'
import App from './App'
import './index.css'
ReactDom.render(<App/>,document.querySelector("#root"))